var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contextLost)?_c('div',{staticClass:"wrapper gradient-bg"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('sceneNormalizing')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }